import { ReactNode, Suspense, forwardRef, useImperativeHandle, useState } from 'react';
import { type Presenter } from './index';
import { useVerticalExpand } from '../hooks';
import React from 'react';
export type ExpandCollapsePresenterProps = React.PropsWithChildren & { fallback?: ReactNode; className?: string };

const ExpandCollapsePresenter = forwardRef<Presenter, ExpandCollapsePresenterProps>(function ExpandCollapsePresenter(
    { children, fallback, className }: ExpandCollapsePresenterProps,
    ref
) {
    const { hide, reveal, ref: elRef } = useVerticalExpand();
    const [show, setShow] = useState(false);

    useImperativeHandle(
        ref,
        (): Presenter & { transition: 'idle' | 'opening' | 'closing' } => ({
            transition: 'idle',
            async open() {
                if (this.transition == 'opening') {
                    return;
                }
                this.transition = 'opening';
                setShow(true);
                setTimeout(async () => {
                    await reveal();
                    this.transition = 'idle';
                }, 0);
            },
            async close() {
                if (this.transition == 'closing' || !show) {
                    return;
                }
                this.transition = 'closing';
                await hide();
                this.transition = 'idle';
                setShow(false);
            },
        }),
        [hide, show, reveal]
    );
    return show ? (
        <div ref={elRef} className={className}>
            <Suspense fallback={fallback}>{children}</Suspense>
        </div>
    ) : (
        <></>
    );
});

export default ExpandCollapsePresenter;
